import styles from "./Portal.module.scss";
import { useWindowSize } from "shared/hooks/useWindowSize";
import { RightPanel } from "./RightPanel";
import { LeftPanel } from "./LeftPanel";

export const PortalConfiguration = () => {
  const { windowInnerHeight } = useWindowSize();

  return (
    <div className={styles.portalConfigurationWrapper}>
      <div
        className={styles.portalConfiguration}
        style={{ height: windowInnerHeight - 145 }}
      >
        <LeftPanel />
        <RightPanel />
      </div>
    </div>
  );
};
